import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  LocationOn,
  ShortText,
  Category,
  FlightTakeoff,
  FlightLand,
  TransferWithinAStation,
  ExpandMore,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AIRPORTS } from '../../component/common/Routes/AppRoutes';
import TextInputField from '../../component/ui/FormFields/TextInputField';
import CustomButton from '../../component/ui/FormFields/Button';
import StatusRadioGroup from '../../component/ui/FormFields/StatusRadioGroup';
import { useForm } from 'react-hook-form';
import Loading from '../../component/ui/Loading';
import {
  approveAirportUpdateRequest,
  resetAirportState,
} from '../../redux/Airports/actions/airportActions';
import { toast, ToastContainer } from 'react-toastify';

export default function AirportApproval({ airportId, handleClose }) {
  const { control } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const APPROVAL_ACCEPT = '1';
  const APPROVAL_DENIED = '2';

  const {
    loading: viewLoading,
    data: airportData,
    error,
  } = useSelector((state) => state?.airport?.airportDetails || {});

  const airportApprove = useSelector(
    (state) => state?.airport?.airportApproval || {}
  );

  const successMessage = airportApprove?.successMessage;
  const errorMessage = airportApprove?.errorMessage;
  const loading = airportApprove?.loading;

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetAirportState());
          navigate(AIRPORTS);
        },
      });
    }
  }, [successMessage, dispatch, navigate]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetAirportState());
        },
      });
    }
  }, [errorMessage, dispatch]);

  if (viewLoading) {
    return <Loading text='Loading Airport detail...' />;
  }

  // const servicesId =
  //   airportData?.data?.airportUpdateLogs?.map(
  //     (item) =>
  //       `${item?.Service?.services} - ${item?.Service?.type_of_name} - ${item?.Service?.type_of_service}`
  //   ) || [];

  // const airportServiceList =
  //   airportData?.data?.airportUpdateLogs?.map((value) => ({
  //     value: value?.price || '-',
  //     label:
  //       `${value?.Service?.services} - ${value?.Service?.type_of_name} - ${value?.Service?.type_of_service}` ||
  //       '-',
  //     serviceType: value?.Service?.arrival_departure_type || '1',
  //     arrivalDescription: value?.arrival || '-',
  //     departureDescription: value?.departure || '-',
  //     transitDescription: value?.transit || '-',
  //   })) || [];
  const servicesId =
    airportData?.data?.airportUpdateLogs?.map((service) =>
      service?.Service?.arrival_departure_type !== 3
        ? `${service?.Service?.services} - ${service?.Service?.type_of_name} - ${service?.Service?.type_of_service}`
        : `${service?.Service?.services} - ${
            service?.Service?.type_of_name
          } - ${service?.Service?.type_of_service} - ${
            service?.Service?.arrival_departure_type === 3
              ? service?.Service?.transit_type_of_service
              : 'Unknown'
          }`
    ) || [];

  const airportServiceList =
    airportData?.data?.airportUpdateLogs?.map((value) => ({
      value: value?.price || '-',
      label:
        value?.Service?.arrival_departure_type !== 3
          ? `${value?.Service?.services} -${value?.Service?.type_of_name} - ${value?.Service?.type_of_service}`
          : `${value?.Service?.services} - ${value?.Service?.type_of_name} - ${
              value?.Service?.type_of_service
            } - ${
              value?.Service?.arrival_departure_type === 3
                ? value?.Service?.transit_type_of_service
                : 'Unknown'
            }`,
      serviceType: value?.Service?.arrival_departure_type || '1',
      arrivalDescription: value?.arrival || '-',
      departureDescription: value?.departure || '-',
      transitDescription: value?.transit || '-',
    })) || [];

  const fields = [
    {
      label: 'Airport Name',
      value: airportData?.data?.airportUpdateLogs?.[0]?.name || '-',
      icon: <LocationOn />,
      xs: 12,
      sm: 6,
    },
    {
      label: 'Airport Code',
      value: airportData?.data?.airportUpdateLogs?.[0]?.short_name || '-',
      icon: <ShortText />,
      xs: 12,
      sm: 6,
    },
    {
      label: 'Airport Type',
      value:
        airportData?.data?.airportUpdateLogs?.[0]?.type === 1
          ? 'Domestic'
          : airportData?.data?.airportUpdateLogs?.[0]?.type === 2
          ? 'International'
          : 'Both' || '-',
      icon: <Category />,
      xs: 12,
      sm: 6,
    },
    {
      label: 'Service',
      value: servicesId || '-',
      icon: <Category />,
      xs: 12,
      sm: 6,
    },
    {
      label: 'Country',
      value:
        airportData?.data?.airportUpdateLogs?.[0]?.country?.country_name || '-',
      icon: <LocationOn />,
      xs: 12,
      sm: 6,
    },
    {
      label: 'State',
      value:
        airportData?.data?.airportUpdateLogs?.[0]?.state?.state_name || '-',
      icon: <LocationOn />,
      xs: 12,
      sm: 6,
    },
  ];

  if (
    airportData?.data?.airportUpdateLogs?.[0]?.country?.country_name === 'India'
  ) {
    fields.push(
      {
        label: 'SGST (%)',
        value: airportData?.data?.airportUpdateLogs?.[0]?.sgst || '-',
        xs: 12,
        sm: 6,
      },
      {
        label: 'CGST (%)',
        value: airportData?.data?.airportUpdateLogs?.[0]?.cgst || '-',
        xs: 12,
        sm: 6,
      }
    );
  } else {
    fields.push({
      label: 'IGST',
      value: airportData?.data?.airportUpdateLogs?.[0]?.tax || '-',
      xs: 12,
      sm: 12,
    });
  }

  const status =
    airportData?.data?.airportUpdateLogs?.[0]?.airport_status === 1
      ? 'Active'
      : 'Inactive' || '-';

  const handleApprovalStatusSubmit = (status) => {
    const payload = {
      airport_id: airportId,
      staff_approve_status: status,
    };
    dispatch(approveAirportUpdateRequest(payload));
  };

  return (
    <>
      <ToastContainer />
      <Box
        className='container'
        sx={{
          maxHeight: '80vh',
          overflow: 'auto',
        }}
      >
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography variant='h5' className='form-heading' gutterBottom>
              Staff Update Details
            </Typography>
            <Grid container spacing={3} className='service-form-margin'>
              {fields?.map((field, index) => (
                <Grid item xs={field.xs || 12} sm={field.sm || 6} key={index}>
                  <TextInputField
                    label={field.label}
                    value={
                      Array.isArray(field.value)
                        ? field.value.join(', ')
                        : field.value
                    }
                    disabled={true}
                    startAdornment={
                      <InputAdornment position='start'>
                        {field.icon}
                      </InputAdornment>
                    }
                  />
                </Grid>
              ))}

              <Grid item xs={12}>
                <Typography variant='h6' sx={{ mt: 2, mb: 2 }}>
                  Service Details
                </Typography>
                {airportServiceList.map((service, index) => (
                  <Accordion key={index} sx={{ mb: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls={`service-panel-${index}-content`}
                      id={`service-panel-${index}-header`}
                    >
                      <Typography variant='subtitle1'>
                        {service.label}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextInputField
                            label='Price'
                            value={service.value}
                            disabled={true}
                          />
                        </Grid>

                        {service.serviceType === 3 ? (
                          <Grid item xs={12}>
                            <TextInputField
                              label='Transit Description'
                              value={service.transitDescription}
                              disabled={true}
                              multiline={true}
                              minRows={3}
                              startAdornment={
                                <InputAdornment position='start'>
                                  <TransferWithinAStation />
                                </InputAdornment>
                              }
                            />
                          </Grid>
                        ) : (
                          <>
                            <Grid item xs={12} sm={6}>
                              <TextInputField
                                label='Arrival Description'
                                value={service.arrivalDescription}
                                disabled={true}
                                multiline={true}
                                minRows={3}
                                startAdornment={
                                  <InputAdornment position='start'>
                                    <FlightLand />
                                  </InputAdornment>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextInputField
                                label='Departure Description'
                                value={service.departureDescription}
                                disabled={true}
                                multiline={true}
                                minRows={3}
                                startAdornment={
                                  <InputAdornment position='start'>
                                    <FlightTakeoff />
                                  </InputAdornment>
                                }
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={4} direction='row'>
                  <Grid item xs={12} sm={6}>
                    <StatusRadioGroup
                      name={'status'}
                      control={control}
                      defaultValue={status}
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box className='button-container' sx={{ marginTop: 4 }}>
              <CustomButton
                variant='contained'
                className='cancel-button'
                text='Decline'
                onClick={() => handleApprovalStatusSubmit(APPROVAL_DENIED)}
              />
              <CustomButton
                variant='contained'
                className='success-button'
                loading={loading}
                text='Approve'
                onClick={() => handleApprovalStatusSubmit(APPROVAL_ACCEPT)}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
